export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0004s_0000_Black-&-White-9.5780e8c6.png";